import Vue from "vue"
import "@mdi/font/css/materialdesignicons.css"
import Vuetify from "vuetify/lib"
import i18n from "../i18n"
Vue.use(Vuetify)

export default new Vuetify({
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },
    iconfont: "mdi",
    dark: false,
    theme: {
        themes: {
            light: {
                primary: "#008B6C",
                secondary: "#424242",
                accent: "#82B1FF",
                error: "#ff493b",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107",
            },
        },
    },
})
